var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { dia } from '@joint/plus';
import { DEFAULT_TEXT_ATTRIBUTES } from './config';
var PADDING = 25;
var CORNER = 20;
export var RESIZE_FLAG = 'autoResized';
var TextNode = /** @class */ (function (_super) {
    __extends(TextNode, _super);
    function TextNode() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TextNode.prototype.defaults = function () {
        return __assign(__assign({}, _super.prototype.defaults), { type: 'TextNode', attrs: {
                root: {
                    cursor: 'move'
                },
                body: {
                    fill: '#FFF',
                    height: 'calc(h)',
                    width: 'calc(w)',
                    stroke: '#DDDDDD',
                    strokeWidth: 0.5,
                    strokeLinejoin: 'round',
                    d: "\n                        M ".concat(CORNER, " 0 0 ").concat(CORNER, " 0 calc(h) L calc(w) calc(h) L calc(w) 0 Z\n                        M 0 ").concat(CORNER, " ").concat(CORNER, " ").concat(CORNER, " ").concat(CORNER, " 0 Z\n                    ")
                },
                label: __assign(__assign({}, DEFAULT_TEXT_ATTRIBUTES), { x: PADDING, y: PADDING, cursor: 'text', textVerticalAnchor: 'top', textAnchor: 'start', lineHeight: 'auto', displayEmpty: true })
            }, z: 2 });
    };
    TextNode.prototype.preinitialize = function () {
        this.markup = [{
                tagName: 'path',
                selector: 'body'
            }, {
                tagName: 'text',
                selector: 'label'
            }];
    };
    TextNode.prototype.adjustSize = function (paper) {
        var _a;
        var view = paper.findViewByModel(this);
        var labelNode = view.findNode('label');
        // Use bounding box without transformations so that our auto-sizing works
        // even on e.g. rotated element.
        var _b = view.getNodeBoundingRect(labelNode).inflate(PADDING), width = _b.width, height = _b.height;
        this.resize(width, height, (_a = {}, _a[RESIZE_FLAG] = true, _a.direction = 'bottom-right', _a));
    };
    TextNode.setupAutoSizeAdjustment = function (paper) {
        var _this = this;
        var model = paper.model;
        model.getElements().forEach(function (el) { return el.adjustSize(paper); });
        model.on('change', function (cell, opt) {
            if (!(cell instanceof _this))
                return;
            if (cell.hasChanged('attrs') && !opt[RESIZE_FLAG]) {
                cell.adjustSize(paper);
            }
        });
    };
    TextNode.create = function (x, y, text, annotations, bodyAttrs) {
        return new TextNode({
            position: { x: x, y: y },
            attrs: {
                label: {
                    text: text,
                    annotations: annotations
                },
                body: bodyAttrs
            }
        });
    };
    TextNode.ANNOTATION_PATH = ['attrs', 'label', 'annotations'];
    TextNode.LABEL_PATH = ['attrs', 'label', 'text'];
    return TextNode;
}(dia.Element));
export { TextNode };
export var textNodes = [
    TextNode.create(450, 50, [
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
        'Fusce maximus dui ac neque fringilla tincidunt.',
        'Pellentesque habitant morbi tristique senectus',
        'et netus et malesuada fames ac turpis egestas.',
        'Orci varius natoque penatibus et magnis dis parturient montes,',
        'nascetur ridiculus mus.'
    ].join('\n'), [], { fill: '#fee68f', stroke: '#b18b01' }),
    TextNode.create(50, 50, [
        'A full-featured text editor',
        '',
        '- rich-text editing',
        '- caret & selections',
        '- caret & selection CSS styling',
        '- word & whole-text selection by double/triple-click',
        '- KB navigation native to the underlying OS',
        '- API for programmatic access',
        '- supports editing of scaled & rotated text',
        ''
    ].join('\n'), [
        {
            start: -1,
            end: 27,
            attrs: {
                'font-size': 24,
                'font-family': 'Pacifico,cursive',
                fill: '#31D0C6',
                'font-weight': 'normal',
                'text-decoration': 'underline',
            },
        },
        {
            start: 31,
            end: 48,
            attrs: {
                'font-size': 24,
                fill: '#FE854F',
                'font-style': 'italic',
            },
        },
        {
            start: 51,
            end: 56,
            attrs: {
                'font-size': 16,
                fill: '#FEB663',
                'text-decoration': 'underline',
            },
        },
        {
            start: 59,
            end: 69,
            attrs: {
                'font-size': 16,
                fill: '#FEB663',
                'text-decoration': 'underline',
            },
        },
        {
            start: 90,
            end: 101,
            attrs: {
                'font-size': 18,
                'font-family': 'Lobster,cursive',
                fill: '#FEB663',
                'text-decoration': 'underline',
            },
        },
        {
            start: 104,
            end: 108,
            attrs: {
                'font-size': 18,
                'font-family': 'Helvetica',
                fill: '#FEB663',
                'text-decoration': 'underline',
            },
        },
        {
            start: 122,
            end: 131,
            attrs: {
                'font-size': 18,
                'font-family': 'Helvetica',
                fill: '#FEB663',
                'text-decoration': 'underline',
            },
        },
        {
            start: 157,
            end: 170,
            attrs: {
                'font-size': 16,
                'font-family': 'Josefin Sans,sans-serif',
                fill: '#FEB663',
                'text-decoration': 'underline',
            },
        },
        {
            start: 201,
            end: 204,
            attrs: {
                'font-size': 16,
                'font-family': 'Josefin Sans,sans-serif',
                fill: '#FE854F',
                'font-weight': 'bold',
            },
        },
        {
            start: 251,
            end: 267,
            attrs: {
                'font-size': 16,
                'font-family': 'Josefin Sans,sans-serif',
                fill: '#7C68FC',
                'font-weight': 'bold',
            },
        },
    ]),
    TextNode.create(550, 380, 'Rotated text\n\nEdit me...', [
        {
            start: -1,
            end: 27,
            attrs: {
                'font-size': 24,
                'font-family': 'Lobster,cursive',
                'fill': '#33334E',
                'font-style': 'normal',
                'font-weight': 'normal',
                'text-decoration': 'none',
            },
        },
    ], {
        fill: '#feb28f',
        stroke: '#fe854d'
    }).rotate(-45),
];
